import { GoogleTagManager } from '@next/third-parties/google'

import { RemoteParamKeys, useToggle } from '@/lib/firebase/hooks'
import { GA_TRACKING_ID } from '@/lib/ga/trackingId'

export const RenderGoogleTagManager = () => {
  const customGtmScriptUrl = useToggle(RemoteParamKeys.CUSTOM_GTM_SCRIPT_URL)

  const isCustomGtmScriptEnabled = customGtmScriptUrl?.enabled

  return (
    <GoogleTagManager
      gtmId={GA_TRACKING_ID}
      {...(isCustomGtmScriptEnabled ? { gtmScriptUrl: 'https://www.kijiji.ca/tms/' } : {})}
    />
  )
}
